import script from "./ClientsPanelList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientsPanelList.vue?vue&type=script&setup=true&lang=ts"

import "./ClientsPanelList.vue?vue&type=style&index=0&id=4d914056&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d914056"]])

export default __exports__